var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content has-text-centered"},[_c('success'),_c('p',{staticClass:"has-text-left"},[_vm._v(_vm._s(_vm.$t('edata_success_note')))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }